import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PartnerModel, SECTIONS, SendDocument, STATUS_PARTNER, STEPS } from 'Pages/prelogin'
import { Callback } from 'Src/types/utilTypes'

export type PreloginState = {
	section: SECTIONS
	step: STEPS
	partner: Partial<PartnerModel> | null
	isLoading: boolean
}

const initialState: PreloginState = {
	section: SECTIONS.MAIN,
	step: STEPS.ORGANIZATION,
	isLoading: false,
	partner: null,
}

export namespace PreloginNS {
	export type SetSection = PayloadAction<SECTIONS>
	export type SetStep = PayloadAction<STEPS>
	export type SetIsLoading = PayloadAction<boolean>
	export type GetPartner = PayloadAction<string>
	export type SetPartner = PayloadAction<Partial<PartnerModel>>
	export type UpdatePartner = PayloadAction<{
		id: string
		data: Partial<PartnerModel>
		callback?: Callback
	}>
	export type ClearAll = PayloadAction
	export type DeleteDocument = PayloadAction<{
		id: number
		partnerId: string
	}>
	export type CreateDocument = PayloadAction<{
		data: SendDocument
	}>
	export type SetStatus = PayloadAction<{
		id: string
		status: STATUS_PARTNER
		callback?: Callback
	}>
}

export const preloginSlice = createSlice({
	name: 'prelogin',
	initialState,
	reducers: {
		setSection: (state, action: PreloginNS.SetSection) => {
			state.section = action.payload
		},
		setStep: (state, action: PreloginNS.SetStep) => {
			state.step = action.payload
		},
		setIsLoading: (state, action: PreloginNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		getPartner: (state, action: PreloginNS.GetPartner) => {},
		setPartner: (state, action: PreloginNS.SetPartner) => {
			state.partner = action.payload
		},
		updatePartner: (state, action: PreloginNS.UpdatePartner) => {},
		clearAll: (state, action: PreloginNS.ClearAll) => {
			state.section = SECTIONS.MAIN
			state.step = STEPS.ORGANIZATION
			state.isLoading = false
			state.partner = null
		},
		deleteDocument: (state, action: PreloginNS.DeleteDocument) => {},
		createDocument: (state, action: PreloginNS.CreateDocument) => {},
		setStatus: (state, action: PreloginNS.SetStatus) => {},
	},
})
